import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["qualificationPanel", "requireCheckbox"]

  connect() {
    this.sync()
  }

  sync() {
    const mode = this.element.querySelector("#inbox-autopilot-mode")?.value
    const qualifyFirst = mode === "qualify_first"
    const required = qualifyFirst || this.requireCheckboxTarget.checked

    if (this.hasQualificationPanelTarget) {
      this.qualificationPanelTarget.hidden = !required
    }

    if (this.hasRequireCheckboxTarget) {
      const row = this.requireCheckboxTarget.closest("label")
      if (row) row.hidden = qualifyFirst
    }
  }
}
